<template>
  <div id="createMember">
    <div
      v-if="env && (env === 'local' || env === 'dev')"
      class="shortcutsWrapper"
    >
      <el-button
        type="danger"
        @click="preset"
      >
        Preset
      </el-button>
    </div>

    <el-card
      class="createCard"
      :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
      shadow="hover"
      :style="{width: dialogWidth}"
    >
      <div
        v-if="state === 'creating'"
        slot="header"
        class="defaultCursor"
      >
        User Registration
      </div>

      <div
        v-loading="loading"
        class="content"
      >
        <el-form
          v-if="state === 'creating'"
          ref="createForm"
          :model="createForm"
          :rules="rules"
        >
          <div v-show="form === 1">
            <el-form-item
              prop="corporate_key"
              label="What is your corporate key?"
              :error="error.corporate_key[0]"
            >
              <el-input
                v-model="createForm.corporate_key"
                placeholder="Corporate key"
              />
            </el-form-item>

            <el-form-item
              prop="business_line"
              :error="error.business_line[0]"
            >
              <div class="selectLabel required">
                What is your line of business?
              </div>
              <el-select
                v-model="createForm.business_line"
                filterable
                placeholder="Select line of business"
              >
                <el-option
                  v-for="(item, BizKey) in businessList"
                  :key="`Business${BizKey}`"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <div class="selectLabel required">
              What is your name?
            </div>
            <el-row :gutter="15">
              <el-col :span="12">
                <el-form-item
                  prop="first_name"
                  :error="error.first_name[0]"
                >
                  <el-input
                    v-model="createForm.first_name"
                    placeholder="First name"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  prop="last_name"
                  :error="error.last_name[0]"
                >
                  <el-input
                    v-model="createForm.last_name"
                    placeholder="Last name"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item
              v-if="createForm.email"
              prop="email"
              label="What is your ING Email address?"
              :error="error.email[0]"
            >
              <el-input
                v-model="createForm.email"
                :disabled="true"
                placeholder="Your Email address"
              />
            </el-form-item>

            <el-form-item
              prop="new_password"
              label="Password"
              :error="error.new_password[0]"
            >
              <el-input
                v-model="createForm.new_password"
                type="password"
                placeholder="Password"
              />
            </el-form-item>

            <el-form-item
              prop="passwordConfirmation"
              label="Password Confirmation"
            >
              <el-input
                v-model="createForm.passwordConfirmation"
                type="password"
                placeholder="Password Confirmation"
              />
            </el-form-item>

            <el-form-item
              prop="payable_country"
              label="Country"
              :error="error.payable_country[0]"
            >
              <el-select
                v-model="selectedLocation"
                filterable
                placeholder="Payable country"
              >
                <el-option
                  v-for="item in vatCountryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item
              prop="time_zone"
              :error="error.time_zone[0]"
            >
              <div class="selectLabel required">
                Timezone
              </div>
              <el-select
                v-model="createForm.time_zone"
                filterable
                placeholder="Select timezone"
              >
                <el-option
                  v-for="item in timezonesList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item
              prop="language"
              :error="error.language[0]"
            >
              <div class="selectLabel required">
                Preferred Coaching Language
              </div>
              <el-select
                v-model="createForm.language"
                filterable
                placeholder="Select language"
              >
                <el-option
                  v-for="item in languagesList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </div><!-- /form 1 -->

          <div v-show="form === 2">
            <el-form-item
              prop="po_number"
              label="Please state your purchase order number"
              :error="error.po_number[0]"
            >
              <el-input
                v-model="createForm.po_number"
                placeholder="Purchase order number"
              />
            </el-form-item>

            <el-form-item
              prop="payable_address"
              label="Please state your full address of the local accounts payable team"
              :error="error.payable_address[0]"
            >
              <el-input
                v-model="createForm.payable_address"
                type="textarea"
                :autosize="{
                  minRows: 3,
                  maxRows: 5,
                }"
                placeholder="Your full address of the local accounts payable team"
              />
            </el-form-item>

            <el-form-item
              prop="cost_centre"
              label="What is the ING cost centre to be invoiced?"
              :error="error.cost_centre[0]"
            >
              <el-input
                v-model="createForm.cost_centre"
                placeholder="ING cost centre"
              />
            </el-form-item>

            <el-form-item
              prop="cost_sort"
              label="What is the ING cost sort?"
              :error="error.cost_sort[0]"
            >
              <el-input
                v-model="createForm.cost_sort"
                placeholder="ING cost sort"
              />
            </el-form-item>

            <div class="selectLabel required">
              What is name of your line manager?
            </div>
            <el-row :gutter="15">
              <el-col :span="12">
                <el-form-item
                  prop="l_manager_first_name"
                  :error="error.l_manager_first_name[0]"
                >
                  <el-input
                    v-model="createForm.l_manager_first_name"
                    placeholder="First name"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  prop="l_manager_last_name"
                  :error="error.l_manager_last_name[0]"
                >
                  <el-input
                    v-model="createForm.l_manager_last_name"
                    placeholder="Last name"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item
              prop="l_manager_email"
              label="What is your line manager's ING Email address?"
              :error="error.l_manager_email[0]"
            >
              <el-input
                v-model="createForm.l_manager_email"
                placeholder="Your line manager's Email address"
              />
            </el-form-item>

            <div class="selectLabel">
              What is your HR business partner's name?
            </div>
            <el-row :gutter="15">
              <el-col :span="12">
                <el-form-item
                  prop="hr_first_name"
                  :error="error.hr_first_name[0]"
                >
                  <el-input
                    v-model="createForm.hr_first_name"
                    placeholder="First name"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  prop="hr_last_name"
                  :error="error.hr_last_name[0]"
                >
                  <el-input
                    v-model="createForm.hr_last_name"
                    placeholder="Last name"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item
              prop="hr_email"
              label="HR business partner’s Email address"
              :error="error.hr_email[0]"
            >
              <el-input
                v-model="createForm.hr_email"
                placeholder="Your HR business partner Email address"
              />
            </el-form-item>

            <el-form-item
              prop="agreed_terms_of_service"
              :error="error.agreed_terms_of_service[0]"
            >
              <el-checkbox v-model="createForm.agreed_terms_of_service">
                I have read and agree to the <el-button
                  type="text"
                  @click="showTermsConditions = true"
                >
                  Terms of Service Agreement
                </el-button> and the <el-button
                  type="text"
                  style="margin-left: 0;"
                  @click="goPrivacyPolicy"
                >
                  Privacy Policy
                </el-button>
              </el-checkbox>
            </el-form-item>
          </div><!-- /form 2 -->

          <div class="buttonWrap">
            <el-button
              v-if="form === 1"
              type="primary"
              round
              @click="goNextPage"
            >
              Next
            </el-button>

            <el-button
              v-if="form === 2"
              type="info"
              round
              @click="form = 1"
            >
              Go back
            </el-button>

            <el-button
              v-if="form === 2"
              type="primary"
              round
              :disabled="!createForm.agreed_terms_of_service"
              @click="submit"
            >
              Submit
            </el-button>
          </div>
        </el-form>

        <div
          v-else-if="state === 'valid'"
          class="validationMessage"
        >
          <el-row
            type="flex"
            :gutter="30"
          >
            <el-col
              :span="responsiveCol.one"
              class="colLogo"
            >
              <i class="title el-icon-circle-check"></i>
            </el-col>
            <el-col
              :span="responsiveCol.two"
              class="colContent"
            >
              <div class="content">
                Your information has been submitted!
                <br />
                You will now be redirected to your
                <router-link :to="{name: 'dashboard'}">
                  dashboard
                </router-link>
                in {{ countDown }} seconds.
              </div>
            </el-col>
          </el-row>
        </div>

        <div
          v-else-if="state === 'error'"
          class="validationMessage"
        >
          <div v-if="errorKey === 'userAlreadyRegistered'">
            Thank you for registering for the Global Leadership Coaching Program. <br /><br />
            Please click <router-link :to="{name: 'login'}">
              here
            </router-link> to access your account.
          </div>
          <el-row
            v-else
            type="flex"
            :gutter="30"
          >
            <el-col
              :span="responsiveCol.one"
              class="colLogo"
            >
              <i class="error el-icon-circle-close"></i>
            </el-col>
            <el-col
              :span="responsiveCol.two"
              class="colContent"
            >
              <div class="content defaultCursor">
                Thank you for your interest in participating in the
                Global Leadership Coaching Program. <br />
                Currently, you do not have access to the program. <br />
                If you believe this is in error please contact your administrator for assistance.
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>

    <TermsAndConditions :show.sync="showTermsConditions" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import api from '@/api';
import businesses from '@/mixins/businesses';
import TermsAndConditions from './TermsAndConditions.vue';

export default {
  components: {
    TermsAndConditions,
  },

  props: {
    dialogWidth: {
      type: String,
      default: '50%',
    },
  },

  data() {
    return {
      form: 1,
      formData: {
        one: [
          'corporate_key',
          'business_line',
          'first_name',
          'last_name',
          'new_password',
          'passwordConfirmation',
          'payable_country',
          'time_zone',
          'language',
        ],
        two: [
          'po_number',
          'payable_address',
          'cost_centre',
          'cost_sort',
          'l_manager_first_name',
          'l_manager_last_name',
          'l_manager_email',
          'agreed_terms_of_service',
        ],
      },
      businessList: businesses.ing,
      timezonesList: [],
      languagesList: [],
      vatCountryList: [],
      showTermsConditions: false,
      createForm: {
        corporate_key: '',
        business_line: '',
        first_name: '',
        last_name: '',
        new_password: '',
        passwordConfirmation: '',
        email: '',
        po_number: '',
        payable_address: '',
        payable_country: null,
        cost_centre: '',
        cost_sort: '',
        l_manager_first_name: '',
        l_manager_last_name: '',
        l_manager_email: '',
        hr_first_name: '',
        hr_last_name: '',
        hr_email: '',
        time_zone: '',
        language: '',
        agreed_terms_of_service: false,
      },
      error: {
        corporate_key: [],
        business_line: [],
        first_name: [],
        last_name: [],
        new_password: [],
        email: [],
        po_number: [],
        payable_address: [],
        payable_country: [],
        cost_centre: [],
        cost_sort: [],
        l_manager_first_name: [],
        l_manager_last_name: [],
        l_manager_email: [],
        hr_first_name: [],
        hr_last_name: [],
        hr_email: [],
        time_zone: [],
        language: [],
        agreed_terms_of_service: [],
      },
      rules: {
        corporate_key: [
          {
            required: true,
            message: 'Please input corporate key',
            trigger: 'blur',
          },
        ],
        business_line: [
          {
            required: true,
            message: 'Please input your line of business',
            trigger: ['blur', 'change'],
          },
        ],
        first_name: [
          {
            required: true,
            message: 'Please input first name',
            trigger: 'blur',
          },
        ],
        last_name: [
          {
            required: true,
            message: 'Please input last name',
            trigger: 'blur',
          },
        ],
        new_password: [
          {
            required: true,
            message: 'Please input password',
            trigger: 'blur',
          },
          {
            min: 8,
            message: 'Password should be at least 8 caracters',
            trigger: 'blur',
          },
          {
            validator: this.checkPasswordForm,
            trigger: 'blur',
          },
        ],
        passwordConfirmation: [
          {
            required: true,
            message: 'Please input password confirmation',
            trigger: 'blur',
          },
          {
            validator: this.checkPasswordConfirmation,
            trigger: ['blur', 'change'],
          },
        ],
        email: [
          {
            required: true,
            message: 'Please input email address',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: ['blur', 'change'],
          },
        ],
        po_number: [
          {
            required: true,
            message: 'Please input purchase order number',
            trigger: 'blur',
          },
        ],
        payable_address: [
          {
            required: true,
            message: 'Please input full address of the local accounts payable team',
            trigger: 'blur',
          },
        ],
        payable_country: [
          {
            required: true,
            message: 'Please select the payable country',
            trigger: ['blur', 'change'],
          },
        ],
        cost_centre: [
          {
            required: true,
            message: 'Please input ING cost centre',
            trigger: 'blur',
          },
        ],
        cost_sort: [
          {
            required: true,
            message: 'Please input ING cost sort',
            trigger: 'blur',
          },
        ],
        l_manager_first_name: [
          {
            required: true,
            message: 'Please input first name',
            trigger: 'blur',
          },
        ],
        l_manager_last_name: [
          {
            required: true,
            message: 'Please input last name',
            trigger: 'blur',
          },
        ],
        l_manager_email: [
          {
            required: true,
            message: 'Please input email address',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: ['blur', 'change'],
          },
        ],
        hr_email: [
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: ['blur', 'change'],
          },
        ],
        time_zone: [
          {
            required: true,
            message: 'Please input your timezone',
            trigger: ['blur', 'change'],
          },
        ],
        language: [
          {
            required: true,
            message: 'Please input your timezone',
            trigger: ['blur', 'change'],
          },
        ],
        agreed_terms_of_service: [
          {
            validator(rule, value, callback) {
              if (value !== true) {
                callback(new Error('You need to accept terms and conditions to continue'));
              } else {
                callback();
              }
            },
            required: true,
            trigger: 'change',
          },
        ],
      },
      state: 'creating',
      errorKey: '',
      loading: false,
      countDown: 0,
    };
  },

  computed: {
    env() {
      let env = '';
      if (process.env.VUE_APP_ENV) {
        env = process.env.VUE_APP_ENV;
      }
      return env;
    },

    selectedLocation: {
      get() {
        if (!this.createForm.payable_country) {
          return '';
        }
        return this.createForm.payable_country.id;
      },
      set(location) {
        this.vatCountryList.forEach((item) => {
          if (item.id === location) {
            this.createForm.payable_country = item;
          }
        });
      },
    },

    responsiveCol() {
      const col = {};
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 24;
        col.two = 24;
      } else {
        col.one = 4;
        col.two = 20;
      }
      return col;
    },
  },

  created() {
    this.validateEmail();
  },

  mounted() {
    this.getTimezoneList();
    this.getLanguages();
    this.getVatCountries();
  },

  methods: {
    ...mapActions('user', [
      'login',
    ]),

    preset() {
      this.createForm.corporate_key = 'cor';
      this.createForm.business_line = 'CSD - Risk';
      this.createForm.first_name = 'First';
      this.createForm.last_name = 'Last';
      this.createForm.new_password = 'Qwe123123;';
      this.createForm.passwordConfirmation = 'Qwe123123;';
      this.createForm.po_number = 'order.no';
      this.createForm.payable_address = 'address';
      this.createForm.cost_centre = 'cost centre';
      this.createForm.cost_sort = 'cost sort';
      this.createForm.l_manager_first_name = 'lfirst';
      this.createForm.l_manager_last_name = 'llast';
      this.createForm.l_manager_email = 'line@test.com';
      this.createForm.payable_country = { id: 22, name: 'Belgium' };
      this.createForm.time_zone = 'Europe/Brussels';
      this.createForm.language = 'en';
    },

    goPrivacyPolicy() {
      window.open('https://globalcoachgroup.com/privacy-policy/', '_blank');
    },

    goNextPage() {
      let valid = true;
      this.$refs.createForm.validateField(this.formData.one, (errMsg, field) => {
        // currently (element 2.13.0) and unlike validate(),
        // validateField() has nop way of knowing if the form has error, so we determine ourself
        if (field) {
          valid = false;
        }
      });

      if (valid) {
        this.form += 1;
      }
    },

    async validateEmail() {
      this.loading = true;
      const { uid } = this.$route.params;
      const { token } = this.$route.params;
      try {
        const response = await api.emailValidation(uid, token);
        this.createForm.email = (response.data.email).replace(/(\r\n|\n|\r\s)/gm, '');
        this.state = 'creating';
      } catch (err) {
        // if (err.msg) {
        //   this.$message.error(err.msg);
        // }
        console.log(err);
        this.state = 'error';
        this.errorKey = err.key;
      } finally {
        this.loading = false;
      }
    },

    checkPasswordForm(rule, value, callback) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!";#$%&'()*+,./:<=>?@[^_`{|}\-\]~])[A-Za-z\d!";#$%&'()*+,./:<=>?@[^_`{|}\-\]~]{8,}$/;

      if (!regex.test(value)) {
        callback(new Error('Password must include one upper character[A-Z], one integer[0-9], and one special character'));
      } else {
        callback();
      }
    },

    checkPasswordConfirmation(rule, value, callback) {
      if (value !== this.createForm.new_password) {
        callback(new Error('Password confirmation does not match'));
      } else {
        callback();
      }
    },

    async getTimezoneList() {
      try {
        const response = await api.getTimezoneList();
        this.timezonesList = response.data.map((el) => ({
          value: el.value,
          label: el.display.replace('_', ' '),
        }));
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    async getLanguages() {
      try {
        const response = await api.getCoachLanguages();
        this.languagesList = response.data;
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    async getVatCountries() {
      try {
        const response = await api.getVatCountriesList();
        this.vatCountryList = response.data;
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    submit() {
      this.$refs.createForm.validate(async (valid, fields) => {
        if (valid) {
          this.loading = true;
          try {
            const data = { ...this.createForm };
            delete data.passwordConfirmation;

            await api.memberSignUp(data);

            this.state = 'valid';

            const loginData = {
              email: data.email,
              password: data.new_password,
            };

            this.logUserIn(loginData);
          } catch (err) {
            if (err.field) {
              const { field } = err;
              Object.keys(field).forEach((key, index) => {
                if (key in this.error) {
                  this.error[key] = field[key];
                }

                if (this.formData.one.includes(key)) {
                  this.form = 1;
                }

                if (index === 0) {
                  this.$message.error(field[key][0]);
                }
              });
              window.scrollTo(0, 0);
            }
            console.log(err);
          } finally {
            this.loading = false;
          }
        } else {
          Object.keys(fields).forEach((item, index) => {
            if (this.formData.one.includes(item)) {
              this.form = 1;
            }

            if (index === 0) {
              if (fields[item][0].message) {
                this.$message.error(fields[item][0].message);
              }
            }
          });
          window.scrollTo(0, 0);
        }
      });
    },

    async logUserIn(loginData) {
      try {
        await this.login(loginData);

        this.countDown = 6;
        this.doCountDown();

        const that = this;
        setTimeout(async () => {
          that.$router.push({ name: 'dashboard' }).catch((err) => {});
        }, 5000);
      } catch (err) {
        if (err.msg) {
          console.log(err.msg);
        }
        console.log(err);
      }
    },

    doCountDown() {
      if (this.countDown > 0) {
        [...Array(6)].forEach((item, i) => {
          setTimeout(() => {
            this.countDown -= 1;
          }, 1000 * i);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #createMember {
    width: 100%;

    .createCard {
      // max-width: 660px; // Yeri change: use same width as pulse survey page
      margin: 0 auto;

      .el-card__body {
        .el-form {
          .selectLabel {
            font-size: 16px;
            color: #606266;
            min-height: 40px;
            display: flex;
            align-items: center;

            &.required {
              &::after {
                content: '*';
                color: #f56c6c;
                margin-left: 4px;
              }
            }
          }
        }

        .el-row {
          flex-wrap: wrap;

          .el-col {
            justify-content: center;
            align-self: center;

            &.colLogo {
              text-align: center;

              .title {
                font-size: 70px;
                color: #00ace2;
              }

              .error {
                font-size: 70px;
                color: #dc0000;
              }
            }

            &.colContent {
              padding: 15px;
            }

            .content {
              line-height: 24px;
            }
          }
        }
      }

      .buttonWrap {
        display: flex;
        justify-content: center;

        .el-button {
          width: 50%;
          max-width: 170px;
          padding: 13px 0;
        }
      }
    }
  }

  .shortcutsWrapper {
    text-align: center;
  }
</style>

<style lang="scss">
  #createMember {
    .createCard {
      .el-card__header {
        text-align: center;
        font-size: 18px;
        padding: 30px;
      }

      .el-card__body {
        padding: 30px;

        .el-form {
          .el-select {
            width: 100%;

            .el-input__inner {
              border-radius: 3px;
            }
          }

          .el-checkbox {
            &.is-checked {
              .el-checkbox__label {
                color: #606266;
              }
            }
          }

          .el-form-item__label {
            text-align: left;
            font-size: 16px;
          }
        }
      }

      &.mobileMode {
        .el-card__header {
          padding: 20px;
        }

        .el-card__body {
          padding: 20px;

          .el-form {
            .el-form-item__label {
              line-height: 20px;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
</style>
